export enum APIStreamType {
    VTT_SPRITE = 'VTT_SPRITE',
    THUMBNAIL = 'Thumbnail'
}